/**
 * @summary - Component that Provides Dialog Box
 * @author Yuvasri S (modified by Purushothaman 14-06-2024) 
 * @since 2024-05-28
 */
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

const CustomDialog = ({
  open,
  onClose,
  onConfirm,
  content,
  cancelBtn,
  confirmBtn,
}) => {
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "25%",
          padding: "10px 5px",
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {confirmBtn && (
          <Button variant="contained" onClick={onConfirm} >{confirmBtn}</Button>
        )}
        {cancelBtn && (
          <Button variant="outlined" onClick={onClose}>{cancelBtn}</Button>
        )}

      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
